export default __webpack_public_path__ + "static/media/record.300fc98b.svg";